module.exports = __webpack_public_path__ + "assets/img/location.5d471008.png";